import React from 'react';
import { Box, Input, Typography } from '@mui/joy';

const DateInput = ({ label, labelMinWidth, defaultValue, disabled, name, required }) => {
  const today = new Date().toISOString().split("T")[0];
  return (
    <Box display='flex'>
      <Typography sx={{ minWidth: labelMinWidth, alignSelf: "center" }}>
          {label}: 
      </Typography>
      <Box
        pl='10px'
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          my: 1,
        }}
      >
        <Input
        type="date"
        name={name}
        disabled={disabled}
        required={required}
        defaultValue={defaultValue}
        slotProps={{
          input: {
            max: today, 
          }
        }}
        />
      </Box>
    </Box>
  );
};

export default DateInput;